module.exports = __webpack_public_path__ + "static/media/error.ce3fc13c.svg";